function Error() {
    return(<div>
        <h2>No Page found</h2>
    </div>)
}

export default Error;